export const HEADER_HEIGHT = 64;
export const ASIDE_NAVIGATION_WIDTH = 300;
export const MAX_WIDTH_WITHOUT_ASIDE_NAVIGATION = `calc(100vw - ${ASIDE_NAVIGATION_WIDTH}px)`;
